import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/sharp-solid-svg-icons/faQuestionCircle';
import { Checkbox } from 'ui-components/components/checkbox/';
import { Tooltip } from 'ui-components/components/tooltip';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessagePropType } from '../../../../../prop-types/intl';

import style from '../inputs.module.less';

import messages from './messages';
import { OptionDataPropType, DefaultOptionData } from './prop-types-and-default-props';
import ReturnLabelInputs from './return-label-inputs';

const ReturnLabelOption = ({
  label,
  checked = false,
  onCheck = noop,
  optionData = DefaultOptionData,
  selectedPackage,
  updateOption = noop,
  isInternational = false,
}) => {
  return (
    <div>
      <div className={style['checkbox-with-icon']}>
        <Checkbox checked={checked} disabled={isInternational} label={label} onChange={onCheck} />
        <Tooltip text={<FormattedMessage {...messages.returnLabelWarning} />}>
          <div className={style['information-icon']}>
            <FontAwesomeIcon icon={faQuestionCircle} />
          </div>
        </Tooltip>
      </div>
      {checked && <ReturnLabelInputs optionData={optionData} selectedPackage={selectedPackage} updateOption={updateOption} />}
    </div>
  );
};

ReturnLabelOption.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: OptionDataPropType,
  selectedPackage: PropTypes.object,
  updateOption: PropTypes.func,
  isInternational: PropTypes.bool,
};

export default ReturnLabelOption;
